'use strict'
let moment = require("moment");
export default {
    list: [
        '@currentUser',
        '@defaultCampaignId',
        '@defaultEmployeeId',
        '@activeSingleCampaignId',
        '@activeMultiCampaignIdCSV',
        '@today',
        '@startOfDay',
        '@endOfDay',
        '@startOfWeek',
        '@startOfMonth',
        '@startOfMonthSubtractSevenDays',
        '@endOfMonth',
        '@endOfMonthPlusSevenDays',
        '@startOfPreviousMonth',
        '@endOfPreviousMonth',
        '@yesterday',
        '@tomorrow'
    ],
    getObject: (object = {}) => {
        try{
            let cObject = JSON.parse(JSON.stringify(object));
            for(let key in cObject){
                switch (cObject[key]) {
                    case '@currentUser':
                        cObject[key] = `${app.auth.user.id}`;
                        break;
                    case '@defaultCampaignId':
                        cObject[key] = app.auth.user.default_campaign_id;
                        break;
                    case '@defaultEmployeeId':
                        let employee_id = app.auth.user.data_campaigns.find(campaign => campaign.campaign_id === app.auth.user.default_campaign_id).employee_id
                        cObject[key] = employee_id;
                        break;
                    case '@activeSingleCampaignId':
                        cObject[key] = app.activeSingleCampaign;
                        break;
                    case '@activeMultiCampaignIdCSV':
                        cObject[key] = app.activeMultiCampaigns.map(e => e.id).join();
                        break;
                    case '@today':
                        cObject[key] = moment().format('YYYY-MM-DD HH:mm:ss');
                        break;
                    case '@startOfDay':
                        cObject[key] = moment().startOf('day').format('YYYY-MM-DD HH:mm');
                        break;
                    case '@endOfDay':
                        cObject[key] = moment().endOf('day').format('YYYY-MM-DD HH:mm');
                        break;
                    case '@startOfWeek':
                        cObject[key] = moment().startOf('week').format('YYYY-MM-DD HH:mm');
                        break;
                    case '@startOfMonth':
                        cObject[key] = moment().startOf('month').format('YYYY-MM-DD HH:mm');
                        break;
                    case '@startOfMonthSubtractSevenDays':
                        cObject[key] = moment().startOf('month').subtract(7, 'days').format('YYYY-MM-DD HH:mm');
                        break;
                    case '@endOfMonth':
                        cObject[key] = moment().endOf('month').format('YYYY-MM-DD HH:mm');
                        break;
                    case '@endOfMonthPlusSevenDays':
                        cObject[key] = moment().endOf('month').add(7, 'days').format('YYYY-MM-DD HH:mm');
                        break;
                    case '@startOfPreviousMonth':
                        cObject[key] = moment(new Date()).subtract(1, "month").startOf("month").format('YYYY-MM-DD HH:mm');
                        break;
                    case '@endOfPreviousMonth':
                        cObject[key] = moment(new Date()).subtract(1, "month").endOf("month").format('YYYY-MM-DD HH:mm');
                        break;
                    case '@yesterday':
                        cObject[key] = moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss');
                        break;
                    case '@tomorrow':
                        cObject[key] = moment().add(1, 'days').format('YYYY-MM-DD HH:mm:ss');
                        break;
                    default:
                        break;
                }
            }
            return cObject;
        }catch(err){
            console.log(err);
            return object;
        }
    }
}
